import { useMutation, useQueryClient } from '@tanstack/react-query';
import http from 'helpers/requests';

export const useCreateDeclarant = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (declarant) => {
      const response = await http.post('/declarant', declarant);
      return response.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['declarant'] });
    },
  });
};
